import { API_BASE_HOST, BASE_HOST } from "@/config/config";
import config from "@/utils/config.js";
import md5 from "js-md5";

const state = () => ({
  GameAppInfo: "",
  baseInfo: {
    appName: "",
    createTime: "",
    iconpath: "",
    state: "",
    version: "",
    onlineVersion: ""
  }
});
const mutations = {
  clearVuexData(state, data) {
    state.baseInfo = {
      appName: "",
      createTime: "",
      iconpath: "",
      state: "",
      version: "",
      onlineVersion: ""
    };
    state.GameAppInfo = "";
  },
  setAppInfo(state, data) {
    var newdata = {
      createTime: config.NewData(data.createTime),
      appName: data.appName,
      defaultLanguage: data.defaultLanguage
    };
    state.baseInfo = newdata;
    state.GameAppInfo = data;
  },
  setNewGameInfo(state, data) {
    var newdata = {
      createTime: config.NewData(data.gameDeveloperVo.createTime),
      version: data.gameDeveloperVo.status,
      appName: data.gameDeveloperVo.name,
      state: data.gameDeveloperVo.status,
      iconpath: data.gameDeveloperVo.icon,
      onlineVersion: data.onlineVersion
    };

    var newtext = data.gameDeveloperVo.name.find(
      item => item.lang.toLowerCase() == localStorage.getItem("mp_lang")
    );
    if (!newtext) {
      newdata.appName = data.gameDeveloperVo.name[0].values;
    } else {
      newdata.appName = newtext.values;
    }
    state.baseInfo = newdata;
    state.GameAppInfo = data;
  },
  setAppInfoState(state, data) {
    if (state.baseInfo.state == 4) {
      return;
    }

    state.baseInfo.state = data.state;
  },

  setCPInfo(state, data) {
    data.baseInfo.appInfo = JSON.parse(data.baseInfo.appInfo);
    data.baseInfo.appLang = JSON.parse(data.baseInfo.appLang);
    data.baseInfo.appName = JSON.parse(data.baseInfo.appName);
    var newdata = {
      createTime: config.NewData(data.baseInfo.createTime),
      version: data.appState,
      appName: "",
      state: data.state,
      iconpath: data.baseInfo.iconpath
    };
    var newtext = data.baseInfo.appName.find(
      item => item.lang.toLowerCase() == localStorage.getItem("mp_lang")
    );
    if (!newtext) {
      newdata.appName = data.baseInfo.appName[0].values;
    } else {
      newdata.appName = newtext.values;
    }
    state.baseInfo = newdata;
    console.log("newdata", newdata);
    state.GameAppInfo = data;
  },

  setCPInfoState(state, data) {
    if (state.baseInfo.state == 4) {
      return;
    }
    state.baseInfo.state = data.state;
  }
};

const getters = {};

const getSign = params => {
  const parts = [];

  if (params) {
    const keys = Object.keys(params).sort();
    for (const key of keys) {
      const value = params[key];
      if (value !== undefined && value !== null && value !== "") {
        parts.push(`${key}=${value}`);
      }
    }
    const str = parts.join("&");
    return md5(str).toString();
  }
  return "";
};

const actions = {
  // 清除VUEX的数据
  clearVuexDataContent({ state, commit, dispatch }) {
    commit("clearVuexData", "");
  },
  async myPost($axios, url, ...postData) {
    try {
      var res = await $axios.post(
        url,
        {
          ...postData[0],
          lang: localStorage.getItem("mp_lang"),
          token: localStorage.getItem("mp_accessToken") || "none",
          accessToken: localStorage.getItem("mp_accessToken") || "none"
        },
        {
          headers: {
            Authorization: localStorage.getItem("mp_accessToken") || "none",
            sign: getSign(postData[0])
          }
        }
      );
    } catch (error) {
      console.log("error", error);
    }
    return res;
  },
  async myPut($axios, url, ...postData) {
    var res = await $axios.put(
      url,
      {
        ...postData[0],
        lang: localStorage.getItem("mp_lang"),
        token: localStorage.getItem("mp_accessToken") || "none",
        accessToken: localStorage.getItem("mp_accessToken") || "none"
      },
      {
        headers: {
          Authorization: localStorage.getItem("mp_accessToken") || "none",
          sign: getSign(postData[0])
        }
      }
    );

    return res;
  },
  async myDelete($axios, url, ...postData) {
    var res = await $axios.delete(url, {
      headers: {
        Authorization: localStorage.getItem("mp_accessToken") || "none",
        sign: getSign(postData[0])
      }
    });

    return res;
  },
  async myGet($axios, url, ...postData) {
    var res = await $axios.get(url, {
      headers: {
        token: localStorage.getItem("mp_accessToken") || "none",
        Authorization: localStorage.getItem("mp_accessToken") || "none",
        "Accept-Language": localStorage.getItem("mp_lang"),
        sign: getSign(postData[0])
      },
      params: {
        ...postData[0]
      }
    });
    return res;
  },

  //获取用户应用列表
  async AppList({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myGet(
      $axios,
      `${BASE_HOST}/api/v1/app/admin/config`,
      {
        ...postData
      }
    );

    return res.data;
  },

  //获取app下的游戏列表 AppGameList
  async AppGameList({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myGet(
      $axios,
      `${BASE_HOST}/api/v1/game/app/game`,
      {
        ...postData
      }
    );

    return res.data;
  },


  async getGameOnlineList(
    { state, commit, dispatch },
    { $axios, ...postData }
  ) {
    const res = await actions.myGet(
      $axios,
      `${BASE_HOST}/api/v1/game/gameOnline`,
      {
        ...postData
      }
    );
    return res.data;
  },

  //删除应用
  async AppDelete({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myDelete(
      $axios,
      `${BASE_HOST}/api/v1/app/admin/config/${postData.id}`
    );

    return res.data;
  },

  // 新版平台游戏数据-查询
  async getGameList({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myGet(
      $axios,
      `${BASE_HOST}/api/v1/game/admin/gameDeveloper`,
      {
        ...postData
      }
    );

    console.log("getGameList", res);
    return res.data;
  },

  // 新版 平台游戏数据-上架 /admin/gameDeveloper/up/{id}
  async gameUp({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myPost(
      $axios,
      `${BASE_HOST}/api/v1/game/admin/gameDeveloper/up/${postData.id}`
    );
    return res.data;
  },
  async gameDown({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myPost(
      $axios,
      `${BASE_HOST}/api/v1/game/admin/gameDeveloper/down/${postData.id}`
    );
    return res.data;
  },

  // 创建应用基本信息
  async CreateAppInfo({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myPost(
      $axios,
      `${BASE_HOST}/api/v1/app/admin/config`,
      {
        ...postData
      }
    );
    return res.data;
  },
  // 新版 平台游戏数据-创建/admin/gameDeveloper
  async createGameDeveloper(
    { state, commit, dispatch },
    { $axios, ...postData }
  ) {
    const res = await actions.myPost(
      $axios,
      `${BASE_HOST}/api/v1/game/admin/gameDeveloper`,
      {
        ...postData
      }
    );
    return res.data;
  },

  // 获取应用基本信息
  async AppInfo({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myGet(
      $axios,
      `${BASE_HOST}/api/v1/app/admin/config/${postData.id}`
    );

    if (res.data.code == 200) {
      commit("setAppInfo", res.data.data);
    }
    return res.data;
  },
  // 应用实例表-创建 /instances https://data.just4fun.sg/api/v1/app /instances
  async createAppInstances(
    { state, commit, dispatch },
    { $axios, ...postData }
  ) {
    const res = await actions.myPost(
      $axios,
      `${BASE_HOST}/api/v1/app/instances`,
      {
        ...postData
      }
    );
    return res.data;
  },

  // 应用实例表-修改
  async updateAppInstances(
    { state, commit, dispatch },
    { $axios, ...postData }
  ) {
    const res = await actions.myPut(
      $axios,
      `${BASE_HOST}/api/v1/app/instances`,
      {
        ...postData
      }
    );
    return res.data;
  },

  // 应用实例表-删除
  async deleteAppInstances(
    { state, commit, dispatch },
    { $axios, ...postData }
  ) {
    const res = await actions.myDelete(
      $axios,
      `${BASE_HOST}/api/v1/app/instances/${postData.id}`
    );
    return res.data;
  },

  // 新版 平台游戏数据-游戏信息页详情 /admin/gameDeveloper/info/{id}
  async getGameDeveloperInfo(
    { state, commit, dispatch },
    { $axios, ...postData }
  ) {
    const res = await actions.myGet(
      $axios,
      `${BASE_HOST}/api/v1/game/admin/gameDeveloper/info/${postData.gameId}`
    );
    const data = res.data;
    if (data.code == 200) {
      data.data.gameDeveloperVo.gameLang = JSON.parse(
        data.data.gameDeveloperVo.gameLang || "[]"
      );
      data.data.gameDeveloperVo.name = JSON.parse(
        data.data.gameDeveloperVo.name || "[]"
      );
      data.data.gameDeveloperVo.description = JSON.parse(
        data.data.gameDeveloperVo.description || "[]"
      );

      data.data.gameDeveloperVo.tagId = JSON.parse(
        data.data.gameDeveloperVo.tagId || "[]"
      );
      data.data.gameDeveloperVo.tagCode = JSON.parse(
        data.data.gameDeveloperVo.tagCode || "[]"
      );

      commit("setNewGameInfo", data.data);
    }
    return data;
  },

  //更新应用基本信息
  async UpdateAppBaseInfo(
    { state, commit, dispatch },
    { $axios, ...postData }
  ) {
    const res = await actions.myPut(
      $axios,
      `${BASE_HOST}/api/v1/app/admin/config`,
      {
        ...postData
      }
    );

    return res.data;
  },

  // 新版 游戏提交审核 /admin/gameDeveloper/submit/audit
  async submitAuditGame({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myPost(
      $axios,
      `${BASE_HOST}/api/v1/game/admin/gameDeveloper/submit/audit`,
      {
        ...postData
      }
    );
    return res.data;
  },
  // 新版 平台游戏数据-取消审核 /admin/gameDeveloper/cancel/audit/{id}
  async cancelAuditGame({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myPost(
      $axios,
      `${BASE_HOST}/api/v1/game/admin/gameDeveloper/cancel/audit/${postData.id}`
    );
    return res.data;
  },

  // 新版 平台游戏数据-发布上线 /admin/gameDeveloper/publish/{id}
  async publishGame({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myPost(
      $axios,
      `${BASE_HOST}/api/v1/game/admin/gameDeveloper/publish/${postData.id}`
    );
    return res.data;
  },

  // 新版平台游戏数据-修改 /admin/gameDeveloper
  async updateGameDeveloper(
    { state, commit, dispatch },
    { $axios, ...postData }
  ) {
    const res = await actions.myPut(
      $axios,
      `${BASE_HOST}/api/v1/game/admin/gameDeveloper`,
      {
        ...postData
      }
    );
    return res.data;
  },

  // 获取运营数据的订单列表
  async HtTrades({ state, commit, dispatch }, { $axios, ...postData }) {
    let res = "";
    // 判断是第三方账号 还是cp账号
    if (
      localStorage.getItem("roleName") &&
      localStorage.getItem("roleName").includes("GAME_DEVELOPER")
    ) {
      res = await actions.myPost(
        $axios,
        `${API_BASE_HOST}/tgadpPayment/HtTrades`,
        {
          ...postData
        }
      );
    } else {
      res = await actions.myPost(
        $axios,
        `${API_BASE_HOST}/tgadpPayment/HtOrders`,
        {
          ...postData
        }
      );
    }

    console.log("HtTrades", res);

    return res.data;
  },

  // 获取营收数据
  async getIncomeList({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myGet(
      $axios,
      `${API_BASE_HOST}/tgaAd/portal/ad/income`,
      {
        ...postData
      }
    );
    console.log("getIncomeList", res);
    return res.data;
  },
  // 获取营收数据总数
  async getIncomeCount({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myGet(
      $axios,
      `${API_BASE_HOST}/tgaAd/portal/ad/income/sum`,
      {
        ...postData
      }
    );
    console.log("getIncomeCount", res);
    return res.data;
  },

  // 获取数据查询范围配置
  async LoadDataMeta({ state, commit, dispatch }, { $axios, ...postData }) {
    let res = await actions.myPost(
      $axios,
      `${API_BASE_HOST}/tgampApp/LoadDataMeta`,
      {
        ...postData
      }
    );
    console.log("LoadDataMeta", res);
    return res.data;
  },

  // 查询活跃数据
  async LoadActData({ state, commit, dispatch }, { $axios, ...postData }) {
    let res = await actions.myPost(
      $axios,
      `${API_BASE_HOST}/tgampApp/LoadActData`,
      {
        ...postData
      }
    );
    console.log("LoadActData", res);
    return res.data;
  },

  // 新版查询活跃数据
  async LoadActDataNew({ state, commit, dispatch }, { $axios, ...postData }) {
    let res = await actions.myGet(
      $axios,
      `${API_BASE_HOST}/tgaEtl/admin/data/view/app/overview`,
      {
        ...postData
      }
    );
    console.log("LoadActDataNew", res);
    return res.data;
  },
  // 下载活跃数据
  async ExportActData({ state, commit, dispatch }, { $axios, ...postData }) {
    let res = await actions.myPost(
      $axios,
      `${API_BASE_HOST}/tgampApp/ExportActData`,
      {
        ...postData
      }
    );
    console.log("ExportActData", res);
    return res.data;
  },
  //查询留存数据
  async LoadRetData({ state, commit, dispatch }, { $axios, ...postData }) {
    let res = await actions.myPost(
      $axios,
      `${API_BASE_HOST}/tgampApp/LoadRetData`,
      {
        ...postData
      }
    );
    console.log("LoadRetData", res);
    return res.data;
  },
  // 聚合日留存数据-现存用户
  async LoadDailyExisting(
    { state, commit, dispatch },
    { $axios, ...postData }
  ) {
    let res = await actions.myGet(
      $axios,
      `${API_BASE_HOST}/tgaEtl/admin/data/view/app/retain/combine/daily/existing`,
      {
        ...postData
      }
    );
    return res.data;
  },
  // 聚合日留存数据-新增用户
  async LoadDailyNewly({ state, commit, dispatch }, { $axios, ...postData }) {
    let res = await actions.myGet(
      $axios,
      `${API_BASE_HOST}/tgaEtl/admin/data/view/app/retain/combine/daily/newly`,
      {
        ...postData
      }
    );
    return res.data;
  },
  // 聚合周留存数据-现存用户
  async LoadWeeklyExisting(
    { state, commit, dispatch },
    { $axios, ...postData }
  ) {
    let res = await actions.myGet(
      $axios,
      `${API_BASE_HOST}/tgaEtl/admin/data/view/app/retain/combine/weekly/existing`,
      {
        ...postData
      }
    );
    return res.data;
  },
  // 聚合周留存数据-新增用户
  async LoadWeeklyNewly({ state, commit, dispatch }, { $axios, ...postData }) {
    let res = await actions.myGet(
      $axios,
      `${API_BASE_HOST}/tgaEtl/admin/data/view/app/retain/combine/weekly/newly`,
      {
        ...postData
      }
    );
    return res.data;
  },
  //  导出留存数据：
  async ExportRetData({ state, commit, dispatch }, { $axios, ...postData }) {
    let res = await actions.myPost(
      $axios,
      `${API_BASE_HOST}/tgampApp/ExportRetData`,
      {
        ...postData
      }
    );
    console.log("ExportRetData", res);
    return res.data;
  },

  // 流量方查询用户游戏数据
  async LoadUserGameData({ state, commit, dispatch }, { $axios, ...postData }) {
    let res = await actions.myPost(
      $axios,
      `${API_BASE_HOST}/tgampApp/LoadUserGameData`,
      {
        ...postData
      }
    );
    console.log("LoadUserGameData", res);
    return res.data;
  },

  // 流量方导出用户游戏数据
  async ExportUserGameData(
    { state, commit, dispatch },
    { $axios, ...postData }
  ) {
    let res = await actions.myPost(
      $axios,
      `${API_BASE_HOST}/tgampApp/ExportUserGameData`,
      {
        ...postData
      }
    );
    console.log("ExportUserGameData", res);
    return res.data;
  },

  // 获取游戏排行榜数据
  async GetRankTables({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myPost(
      $axios,
      `${API_BASE_HOST}/tgampApp/GetRankTables`,
      {
        ...postData
      }
    );
    console.log("GetRankTables", res);
    return res.data;
  },
  // 新版 排名配置表-查询
  async getRankConfigList(
    { state, commit, dispatch },
    { $axios, ...postData }
  ) {
    const res = await actions.myGet(
      $axios,
      `${BASE_HOST}/api/v1/game/admin/rankConfig`,
      {
        ...postData
      }
    );
    console.log("GetRankTables", res);
    return res.data;
  },

  // 获取排行榜信息
  async GetRankTableInfo({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myPost(
      $axios,
      `${API_BASE_HOST}/tgampApp/GetRankTableInfo`,
      {
        ...postData
      }
    );
    console.log("GetRankTableInfo", res);
    return res.data;
  },

  // 添加排行榜
  async AddRankTable({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myPost(
      $axios,
      `${API_BASE_HOST}/tgampApp/AddRankTable`,
      {
        ...postData
      }
    );
    console.log("AddRankTable", res);
    return res.data;
  },

  // 新版 排名配置表-创建
  async createRankConfig({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myPost(
      $axios,
      `${BASE_HOST}/api/v1/game/admin/rankConfig`,
      {
        ...postData
      }
    );
    return res.data;
  },

  // 新版 排名配置表-详情
  async getRankConfigInfo(
    { state, commit, dispatch },
    { $axios, ...postData }
  ) {
    const res = await actions.myGet(
      $axios,
      `${BASE_HOST}/api/v1/game/admin/rankConfig/${postData.id}`
    );
    return res.data;
  },

  // 新版 排名配置表-修改
  async updateRankConfig({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myPut(
      $axios,
      `${BASE_HOST}/api/v1/game/admin/rankConfig`,
      {
        ...postData
      }
    );
    return res.data;
  },
  // 新版 排名配置表-删除
  async deleteRankConfig({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myDelete(
      $axios,
      `${BASE_HOST}/api/v1/game/admin/rankConfig/${postData.id}`
    );
    return res.data;
  },
  // 新版 排名配置表-删除
  async deleteRankConfigData(
    { state, commit, dispatch },
    { $axios, ...postData }
  ) {
    const res = await actions.myDelete(
      $axios,
      `${BASE_HOST}/api/v1/game/admin/rankConfig/data/${postData.id}`
    );
    return res.data;
  },

  // 编辑排行榜
  async EditRankTable({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myPost(
      $axios,
      `${API_BASE_HOST}/tgampApp/EditRankTable`,
      {
        ...postData
      }
    );
    console.log("EditRankTable", res);
    return res.data;
  },

  // 删除排行榜
  async DelRankTable({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myPost(
      $axios,
      `${API_BASE_HOST}/tgampApp/DelRankTable`,
      {
        ...postData
      }
    );
    console.log("DelRankTable", res);
    return res.data;
  },

  // 清除排行榜记录
  async TrunRankTable({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myPost(
      $axios,
      `${API_BASE_HOST}/tgampApp/TrunRankTable`,
      {
        ...postData
      }
    );
    console.log("TrunRankTable", res);
    return res.data;
  },

  // APP提交素材并审核
  async CensorWithMaterial(
    { state, commit, dispatch },
    { $axios, ...postData }
  ) {
    const res = await actions.myPost(
      $axios,
      `${API_BASE_HOST}/tgampApp/CensorWithMaterial`,
      {
        ...postData
      }
    );
    console.log("CensorWithMaterial", res);
    return res.data;
  },

  // 游戏凭证信息表
  async GetGameAuth({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myGet(
      $axios,
      `${BASE_HOST}/api/v1/game/auth/${postData.appId}`,
      {}
    );
    return res.data;
  },

  // 获取支付设置
  async GetPaySecret({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myGet(
      $axios,
      `${BASE_HOST}/api/v1/pay/admin/config/merchant/single?appId=${postData.appId}`,
      {}
    );
    return res.data;
  },

  // 设置支付回调地址
  async SetPayCallback({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myPut(
      $axios,
      `${BASE_HOST}/api/v1/pay/admin/config/merchant`,
      {
        ...postData
      }
    );
    return res.data;
  },

  // 测试通过认证
  async AgreeCensorInfo2({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await $axios.post(
      `${API_BASE_HOST}/tgampGroup/AgreeCensorInfo2`,
      {
        ...postData
      }
    );
    console.log("AgreeCensorInfo2", res);

    return res.data;
  },

  // 测试通过认证
  async CheckCensorApp({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await $axios.post(`${API_BASE_HOST}/tgampApp/CheckCensorApp`, {
      ...postData
    });
    console.log("CheckCensorApp", res);

    return res.data;
  },

  // 获取所有tag列表
  async getTagList({ state, commit, dispatch }, { $axios, ...postData }) {
    // `${API_BASE_HOST}/tgaAd/portal/ad/income`,
    const res = await actions.myGet(
      $axios,
      `${BASE_HOST}/api/v1/game/admin/tag/tree`
    );
    return res.data;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/vuex/modules/game.js